import { ChevronDown } from 'lucide-react-native';
import { memo } from 'react';

import { type CancerTypeFilterProps } from './types';

import {
  Select,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicator,
  SelectDragIndicatorWrapper,
  SelectIcon,
  SelectInput,
  SelectItem,
  SelectPortal,
  SelectScrollView,
  SelectTrigger,
} from '@/components/ui/select';
import { useColors } from '@/hooks/useColors';

export const CancerTypeFilter = memo<CancerTypeFilterProps>(
  ({
    inquiryCancerTypesData,
    selectedCancerFocus,
    setSelectedCancerFocus,
    resetSelectedChatId,
    disabled,
  }) => {
    const { colors } = useColors();

    if (!inquiryCancerTypesData?.length) {
      return null;
    }

    return (
      <Select
        className="min-h-[44px] w-full px-4 pb-1 pt-2 md:hidden"
        onValueChange={(label: string) => {
          setSelectedCancerFocus(label === 'Select All' ? undefined : label);

          resetSelectedChatId();
        }}
        selectedValue={String(selectedCancerFocus || 'Select All')}
        isDisabled={disabled}>
        <SelectTrigger className="w-full items-center justify-between bg-background-0 p-2">
          <SelectInput
            style={{ color: colors.primary[900] }}
            placeholder="Filter by cancer type"
            value={(() => {
              if (disabled) {
                return 'Filter by cancer type';
              }

              if (selectedCancerFocus) {
                return (
                  inquiryCancerTypesData.find((type) => type.shortLabel === selectedCancerFocus)
                    ?.label || ''
                );
              }

              return 'Filter by cancer type';
            })()}
          />
          <SelectIcon as={ChevronDown} />
        </SelectTrigger>

        <SelectPortal>
          <SelectBackdrop />
          <SelectContent className="max-h-[70vh]">
            <SelectDragIndicatorWrapper>
              <SelectDragIndicator />
            </SelectDragIndicatorWrapper>
            <SelectScrollView>
              <SelectItem key="blank" label=" " value="" />
              <SelectItem key="all" label="Select All" value="Select All" />
              {inquiryCancerTypesData?.map((type) => (
                <SelectItem
                  key={type.shortLabel}
                  label={type.label || ''}
                  value={String(type.shortLabel)}
                />
              ))}
            </SelectScrollView>
          </SelectContent>
        </SelectPortal>
      </Select>
    );
  }
);
